"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M11.526 6.206a.5.5 0 01.948 0l1.111 3.296a.5.5 0 00.474.34h3.555a.5.5 0 01.287.91l-2.844 1.991a.5.5 0 00-.187.57l1.094 3.245a.5.5 0 01-.761.569l-2.916-2.042a.5.5 0 00-.574 0l-2.916 2.042a.5.5 0 01-.76-.57l1.093-3.244a.5.5 0 00-.187-.57L6.1 10.752a.5.5 0 01.287-.91H9.94a.5.5 0 00.474-.34l1.111-3.296z" }), "Star");
//# sourceMappingURL=Star.js.map